"use client";

import PatientCard from "@/src/components/cards/patient-card/patient-card";
import ReferralCard from "@/src/components/cards/referral-card/referral-card";
import type { Referral } from "@/src/models/documents/referral";

/** The Information tab. The workflow's progress is on the Steps tab's step cards. */
export function ConfluentReferralInstructions({ referral }: { referral: Referral }) {
  return (
    <div className="flex w-full max-w-2xl flex-col gap-8 sm:min-w-[800px] mx-auto">
      <p className="text-sm text-muted-foreground">
        These are the patient and referral details recorded in Valerie. Review the Steps tab and verify the results in
        Clinicient before completing this task.
      </p>
      <PatientCard patient={referral.patient} />
      <ReferralCard referral={referral} isEditable />
    </div>
  );
}
